export enum ClaimType {
  SuperAdminClaimType = 'SuperAdmin',
  RestaurantManagerClaimType = 'RestaurantManager',
  KitchenStaffClaimType = 'KitchenStaff',
  RestaurantWaiterClaimType = 'RestaurantWaiter',
}
